// Import react elements
import { useMemo, useState } from 'react';

// Import components
import CustomDropdownInput from 'global/components/CustomDropdownInput';
import CreateButton from 'global/components/CreateButton';



//Dropdown to update type, category, and subcategory for selected image/s
const BulkMoveDropdown = ({ imageData, handleMoveSubmit, onCancel, moveWrapperRef }) => {


    // Set state for the 'type'
    const [type, setType] = useState('');

    // Set state for the 'category'
    const [category, setCategory] = useState('');

    // Set state for the 'subcategory'
    const [subcategory, setSubcategory] = useState('');



    // Handle change in the type input
    const handleTypeChange = (newType) => {

        // Set the 'type' as the new type entered
        setType(newType);

        // Clear the category when the type changes
        setCategory('');

        // Clear the subcategory when the type changes
        setSubcategory('');

    };



    // Handle change in the category input
    const handleCategoryChange = (newCategory) => {

        // Set the 'catgegory' as the new category entered
        setCategory(newCategory);

        // Clear the subcategory when the type changes
        setSubcategory('');

    };



    // Handle submit button click
    const handleSubmit = () => {

        // Run the onSubmit function and pass the new type, category and subcat values
        handleMoveSubmit({ type, category, subcategory });

    };



    // Get the 'type' options from the current imageData
    const typeOptions = useMemo(() => {

        // Create a new array by mapping the imageData and setting the types
        return [...new Set(imageData.map(i => i.type))];

        // Update when imageData changes
    }, [imageData]);



    // Get the 'category' options from the current imageData
    const categoryOptions = useMemo(() => {

        // If there's no selected type then return empty - we only want to display catgories that match the type selected
        if (!type) return [];

        // Create a new array of categories by mapping the imageData, filtered by selected 'type'
        return [...new Set(imageData.filter(i => i.type === type).map(i => i.category))];

        // Update when imageData or type changes
    }, [imageData, type]);



    // Get the 'subcategory' options from the current imageData
    const subcategoryOptions = useMemo(() => {

        // If there's no selected category return empty - we only want subcatgories that match the category selected
        if (!category) return [];

        // Create a new array of subcategories by mapping the imageData, filtered by selected 'category'
        return [...new Set(imageData.filter(i => i.category === category).map(i => i.subcategory))];

        // Update when imageData or category changes
    }, [imageData, category]);



    return (

        <div className="bulk-move-dropdown" ref={moveWrapperRef}>

            <CustomDropdownInput
                label="Type"
                value={type}
                setValue={handleTypeChange}
                options={typeOptions}
            />

            <CustomDropdownInput
                label="Category"
                value={category}
                setValue={handleCategoryChange}
                options={categoryOptions}
            />

            <CustomDropdownInput
                label="Subcategory"
                value={subcategory}
                setValue={setSubcategory}
                options={subcategoryOptions}
            />

            <div className="horizontal-align-content-center">

                <CreateButton title="Move" size="s" onClick={handleSubmit} />

                <CreateButton title="Cancel" isCancel={true} size="s" onClick={onCancel} />

            </div>

        </div>

    );

};

export default BulkMoveDropdown;